'use strict';

import dialog from './dialog';
import page from './page';
import util from './util';
import modalExport from './modal';
const modal = modalExport.global;
import validator from './validator';
import analytics from './analytics';

var login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        //o-auth binding for which icon is clicked
        $(document).on('click', '.oAuthIcon', function () {
			 analytics.socialLoginEvent(this.id);
            $(this).parents('form').find('.OAuthProvider').val(this.id);
            $(this).parents('form').find('#socialRedirectUrl').val(window.location.href);
        });
    

        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });

    }
}

//Reset Password
$(document).on('click', '.password-reset', function (e) {
    e.preventDefault();
    if ($('#sign-in-dropdown').length) {
        $('#sign-in-dropdown').foundation('close');
    }
        
    modal.close();
    modal.renderByUrl($(e.target).attr('href')).done(function (response) {
        var $requestPasswordForm = $('[name$="_requestpassword"]');
        var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
        validator.init();
        validator.changeFieldValidation();
        $($submit).on('click', function (e) {
            if (!$requestPasswordForm.valid()) {
                return;
            }
            e.preventDefault();
            var data = $requestPasswordForm.serialize();
            // add form action to data
            data += '&' + $submit.attr('name') + '=';
            // make sure the server knows this is an ajax request
            if (data.indexOf('ajax') === -1) {
                data += '&format=ajax';
            }
            $.ajax({
                type: 'POST',
                url: $requestPasswordForm.attr('action'),
                data: data,
                success: function (response) {
                    if (typeof response === 'object' &&
                                !response.success &&
                                response.error === 'CSRF Token Mismatch') {
                        page.redirect(Urls.csrffailed);
                    } else if (typeof response === 'string') {
                        modal.close();
                        modal.renderContent(response);
                    }
                },
                failure: function () {
                    modal.renderContent('<h1>' + Resources.SERVER_ERROR + '</h1>');
                }
            });
        });
    });
    modal.addCustomClass('forgot-password-modal'); 
});

$(window).on('resize orientationchange', function(){
    if(dialog.isActive()) {
        $('#dialog-container').dialog('option', 'position', {my: 'center', at: 'center', of: window});
    }
});

///Login Greetings
if (window.User.isCustomerAuthenticated != false || window.User.isRegistered == true) {
    var myDate = new Date();
    var hrs = myDate.getHours();
    var mins = myDate.getMinutes();
    var time;
    var greeting;

    mins = ('0' + mins).slice(-2);
    time = hrs + mins;
    time = Number(time);

    if (time >= 300 && time <= 1159) {
        greeting = window.Resources.GREETINGS_MORNING;
    } else if (time >= 1200 && time <= 1700) {
        greeting = window.Resources.GREETINGS_AFTERNOON;
    } else {
        greeting = window.Resources.GREETINGS_EVENING;
    }

    $('#login-greetings').text(greeting).closest('a').each(function() {
        $(this).attr('title', greeting + ' ' + $(this).attr('data-username'))
    });
}

export default login;